var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTrashOutline = function SvgTrashOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 10a1 1 0 0 1 1 1v6a1 1 0 0 1-2 0v-6a1 1 0 0 1 1-1M14 10a1 1 0 0 1 1 1v6a1 1 0 0 1-2 0v-6a1 1 0 0 1 1-1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M13 0a5.01 5.01 0 0 1 4.9 4H21a1 1 0 0 1 0 2h-1v13a5.007 5.007 0 0 1-5 5H9a5.007 5.007 0 0 1-5-5V6H3a1 1 0 0 1 0-2h3.1A5.01 5.01 0 0 1 11 0zM6 19a3 3 0 0 0 3 3h6a3 3 0 0 0 3-3V6H6zm5-17a3.01 3.01 0 0 0-2.83 2h7.66A3.01 3.01 0 0 0 13 2z",
    clipRule: "evenodd"
  })));
};
export default SvgTrashOutline;